import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { useBoundStore } from "useStore";

const datePickerStyles = {
  width: 150,
  "& .MuiOutlinedInput-root": { backgroundColor: "#fff", borderRadius: "8px" },
  "& .MuiInputBase-input": {
    backgroundColor: "#fff !important",
    borderRadius: "8px",
    WebkitBoxShadow: "0 0 0 1000px white inset",
  },
};

export default function DateFilter() {
  const searchObject = useBoundStore((state) => state.soTallerSearch);
  const setSearchObject = useBoundStore((state) => state.setSoTallerSearch);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Desde"
          value={searchObject.startDate}
          inputFormat="dd/MM/yyyy"
          onChange={(newValue) =>
            setSearchObject({ ...searchObject, startDate: newValue })
          }
          components={{
            OpenPickerIcon: () => (
              <CalendarTodayOutlinedIcon sx={{ color: "#0000008F" }} />
            ),
          }}
          slots={{ openPickerIcon: CalendarTodayOutlinedIcon }}
          slotProps={{
            openPickerIcon: { sx: { color: "#0000008F" } },
            textField: { sx: datePickerStyles },
          }}
          renderInput={(params) => (
            <TextField {...params} sx={datePickerStyles} />
          )}
        />
      </LocalizationProvider>

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label="Hasta"
          value={searchObject.endDate}
          inputFormat="dd/MM/yyyy"
          onChange={(newValue) =>
            setSearchObject({ ...searchObject, endDate: newValue })
          }
          components={{
            OpenPickerIcon: () => (
              <CalendarTodayOutlinedIcon sx={{ color: "#0000008F" }} />
            ),
          }}
          slots={{ openPickerIcon: CalendarTodayOutlinedIcon }}
          slotProps={{
            openPickerIcon: { sx: { color: "#0000008F" } },
            textField: { sx: datePickerStyles },
          }}
          renderInput={(params) => (
            <TextField {...params} sx={datePickerStyles} />
          )}
        />
      </LocalizationProvider>
    </>
  );
}
